import { useEffect } from 'react';
import { useSubscriptionStore } from '@/stores/subscriptionStore';
import { supabase } from '@/integrations/supabase/client';

export function SubscriptionProvider({ children }: { children: React.ReactNode }) {
  const loadSubscription = useSubscriptionStore((state) => state.loadSubscription);

  useEffect(() => {
    // Carregar assinatura quando o componente monta
    loadSubscription();

    // Escutar mudanças de autenticação
    const { data: { subscription: authSub } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session) {
        // Usuário logado, carregar assinatura
        loadSubscription();
      } else {
        // Usuário deslogado, limpar estado
        useSubscriptionStore.setState({
          currentPlan: null,
          patientsCount: 0,
          loading: false,
        });
      }
    });

    return () => {
      authSub.unsubscribe();
    };
  }, [loadSubscription]);

  useEffect(() => {
    let channel: ReturnType<typeof supabase.channel> | null = null;

    const setupRealtime = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      channel = supabase
        .channel(`profile-subscription-${user.id}`)
        .on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'profiles',
            filter: `id=eq.${user.id}`,
          },
          () => {
            loadSubscription();
          }
        )
        .subscribe();
    };

    setupRealtime();

    return () => {
      if (channel) supabase.removeChannel(channel);
    };
  }, [loadSubscription]);

  return <>{children}</>;
}


